import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtener() {
    var url = ConfigAPI.baseURL + "reports-visit" + Session.getToken();
    return instance.get(url);
  },
  mostrar(id) {
    var url = ConfigAPI.baseURL + "reports-visit/" + id + Session.getToken();
    return instance.get(url);
  },
  agregar(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "reports-visit" + Session.getToken();
    return instance.post(url,params);
  },
  editar(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "reports-visit/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminar(id) {
    var url = ConfigAPI.baseURL + "reports-visit/"+ id + Session.getToken();
    return instance.delete(url);
  }, 

  filtrarReport(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "reports-visit/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },   
  filtrarAnalisis(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports-visit/filter/analysis" + Session.getToken();    
    return instance.post(url,params)
  },

  obtenerClientes() {
    var url = ConfigAPI.baseURL + "customers" + Session.getToken();
    return instance.get(url);
  },
  obtenerClientesByZonas(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "sellers/filter/customerByZone" + Session.getToken();
    return instance.post(url,params);     
  },
  obtenerZonasByVendedor(data) {
    var params = data
    var url = ConfigAPI.baseURL + "sellers/filter/zonesBySeller" + Session.getToken();
    return instance.post(url,params);
  },   
  obtenerStaff() {
    var url = ConfigAPI.baseURL + "staff" + Session.getToken();
    return instance.get(url);
  },
    
  obtenerVendedores() {
    var url = ConfigAPI.baseURL + "sellers" + Session.getToken();
    return instance.get(url);
  }, 
  mostrarVendedor(id) {
    var url = ConfigAPI.baseURL + "sellers/" + id + Session.getToken();
    return instance.get(url);
  },  
}

export default servicesAPI;
